import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";
import { Checkbox, Select } from "../workspace";
import { LineItems, SkylightPrices, SunTunnelPrices, Labor, Commissions } from "./PriceTablesParts";
import { MiscPriceBlock, SkylightCostBlock } from "./CostTablesParts";

const AdminPriceTables = () => {
  const {
    lists,
    prices,
    handleChange,
    getLists,
    getPrices,
    updateSkylightPrices,
    createRecord,
    isLoading,
  } = useAppContext();

  const mostRecentPriceSheet = lists?.listPriceSheets[0]?.id;
  const nextRecentPriceSheet = lists?.listPriceSheets[1]?.id;
  const [priceSheet, setPriceSheet] = useState(mostRecentPriceSheet);
  const [formerPriceSheet, setFormerPriceSheet] = useState(nextRecentPriceSheet);
  const [enableEdits, setEnableEdits] = useState(false);
  const [showPrevious, setShowPrevious] = useState(false);
  const [menu, setMenu] = useState("Price Tables");
  const [category, setCategory] = useState("Residential");

  const handleInput = (e, index, priceTable) => {
    // individual price
    const property = e.target.name;
    const value = Math.abs(e.target.value);
    // find price table and row
    let table = prices[priceTable].filter(
      (price) => price.price_sheets_id === parseInt(priceSheet)
    );
    let formerTable = prices[priceTable].filter(
      (price) => price.price_sheets_id === parseInt(formerPriceSheet)
    );
    // Sort the row order
    if (priceTable === "extrasPrices") {
      table = table.sort((a, b) => {
        const sizeList = lists.listExtras?.map((item) => item.id);
        const aRank = sizeList.indexOf(a.extras_id);
        const bRank = sizeList.indexOf(b.extras_id);
        return aRank - bRank;
      });
    } else {
      table = table.sort((a, b) => {
        const sizeList = lists.listSkylightSizes?.map((size) => size.text);
        const aRank = sizeList.indexOf(a.size || a.diameter);
        const bRank = sizeList.indexOf(b.size || b.diameter);
        return aRank - bRank;
      });
    }
    console.log("priceTable:", priceTable);
    // build new row/table with updated price
    const newRow = { ...table[index], [property]: value };
    let newTable = [...table, ...formerTable]; // create a copy of the price table
    newTable[index] = newRow; // replace with the modified row
    // update state with new price table
    const name = `prices.${priceTable}`;
    // console.log("prices:", prices)
    // console.log("priceSheet:", priceSheet)
    // console.log("formerPriceSheet:", formerPriceSheet)
    handleChange({ baseObject: { ...prices }, name, value: newTable });
  };

  // Navigation commands for table cursors
  const handleKeyDown = (e) => {
    const [, tableName, column, index] = e.target.id.match(/(\D*)-(\D*)-(\d*)/);

    let newInput, newIndex;
    const newName = `${tableName}-${column}-`;
    const inputs = Array.from(document.querySelectorAll("input"));

    if (e.key === "ArrowUp") {
      e.preventDefault(); // Prevent inner-input cursor movement
      newIndex = Number(index) - 1;
      newInput = document.getElementById(newName + newIndex);
      newInput.select();
    } else if (e.key === "ArrowDown") {
      e.preventDefault(); // Prevent inner-input cursor movement
      newIndex = Number(index) + 1;
      newInput = document.getElementById(newName + newIndex);
      newInput.select();
    } else if (e.key === "ArrowLeft") {
      e.preventDefault(); // Prevent inner-input cursor movement
      const currentIndex = inputs.indexOf(e.target);
      inputs[currentIndex - 1].select();
    } else if (e.key === "ArrowRight") {
      e.preventDefault(); // Prevent inner-input cursor movement
      const currentIndex = inputs.indexOf(e.target);
      inputs[currentIndex + 1].select();
    } else if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission
      newIndex = Number(index) + 1;
      newInput = document.getElementById(newName + newIndex);
      newInput.select();
    }
  };

  const handleCheck = (value) => {
    setEnableEdits(value);
  };

  const handleTableSave = async () => {
    console.log("Save price table changes...");
    console.log("prices:", prices);

    // Save Residential Skylight and Sun Tunnel Price Tables
    await updateSkylightPrices({
      objectName: "skylightPrices",
      tableName: "tbl4skylight_prices",
      priceSheetId: priceSheet,
      url: "prices/update",
    });
    await updateSkylightPrices({
      objectName: "sunTunnelPrices",
      tableName: "tbl4sun_tunnel_prices",
      priceSheetId: priceSheet,
      url: "prices/update-sun-tunnels",
    });
    // Save Roofer Residential Skylight and Sun Tunnel Price Tables
    await updateSkylightPrices({
      objectName: "rooferSkylightPrices",
      tableName: "tbl4roofer_skylight_prices",
      priceSheetId: priceSheet,
      url: "prices/update",
    });
    await updateSkylightPrices({
      objectName: "rooferSunTunnelPrices",
      tableName: "tbl4roofer_sun_tunnel_prices",
      priceSheetId: priceSheet,
      url: "prices/update-sun-tunnels",
    });
    // Save Cost Tables
    await updateSkylightPrices({
      objectName: "skylightCosts",
      tableName: "tbl4skylight_costs",
      priceSheetId: priceSheet,
      url: "prices/update-costs",
    });
    await updateSkylightPrices({
      objectName: "sunTunnelCosts",
      tableName: "tbl4sun_tunnel_costs",
      priceSheetId: priceSheet,
      url: "prices/update-sun-tunnel-costs",
    });
    // Save Line Items and Labor Price Tables
    await updateSkylightPrices({
      objectName: "extrasPrices",
      priceSheetId: priceSheet,
      url: "prices/update-line-items",
    });
    await updateSkylightPrices({
      objectName: "laborPrices",
      priceSheetId: priceSheet,
      url: "prices/update-labor",
    });
    await updateSkylightPrices({
      objectName: "commissions",
      priceSheetId: priceSheet,
      url: "prices/update-commissions",
    });
  };

  let pricePackage = {
    priceSheet,
    formerPriceSheet,
    handleInput,
    enableEdits,
    showPrevious,
    handleKeyDown,
  };

  const handleSelect = (e) => {
    console.log("e.target:", e.target);
    const newId = e.target.value;
    setPriceSheet(newId);
    const formerIndex = e.target.selectedIndex;
    const formerId = prices.priceSheets[formerIndex].id;
    setFormerPriceSheet(formerId);
  };

  const createPriceSheet = async () => {
    const path = "prices/create";
    const tableName = "tbl4price_sheets";
    // Build price sheet name
    const today = new Date();
    const year = today.getFullYear().toString().slice(-2); // Get the last two digits of the year
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Get the month (0-11) and pad with leading zero if needed
    const baseName = `v${month}-${year}`;
    // Check if the last version matches the proposed priceSheetName
    const lastVersion = prices.priceSheets[0].price_sheet_version;
    let priceSheetName = baseName;
    if (lastVersion && lastVersion.startsWith(baseName)) {
      // Extract the suffix letter from the last version
      const suffix = lastVersion.slice(baseName.length);
      // Determine the next letter in the sequence
      const nextSuffix = suffix ? String.fromCharCode(suffix.charCodeAt(0) + 1) : "a";
      priceSheetName = baseName + nextSuffix;
    }
    // Add record to database and load the changed state objects
    const tableObject = { price_sheet_version: priceSheetName };
    const newRow = await createRecord(path, tableObject, tableName);
    await getLists();
    await getPrices();
    setPriceSheet(newRow.id);
    const formerId = prices.priceSheets[1].id;
    setFormerPriceSheet(formerId);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="group whole price-tables">
      <form onSubmit={handleSubmit} className="form">
        <div className="form-center">
          {/* Price Tables/Cost Tables toggle */}
          {["Price Tables", "Cost Tables"].map((title, index) => {
            return (
              <div className="" key={index}>
                <button
                  name={title}
                  className={menu === title ? "selected btn btn-block" : "btn btn-block"}
                  type="button"
                  onClick={() => setMenu(title)}
                  disabled={isLoading}
                >
                  {isLoading ? "please wait..." : title}
                </button>
              </div>
            );
          })}
          <h3 className="whole">{menu}</h3>
          {/* Header Controls */}
          <div className="one-half flex-parent">
            {/* Add new button */}
            <button
              name={"addNew"}
              className={"btn one-fourth green"}
              type="button"
              onClick={createPriceSheet}
              disabled={isLoading}
            >
              {isLoading ? "please wait..." : "Add new"}
            </button>
            <div className="three-fourths">
              <Select
                name="priceSheet"
                labelText="Price Sheet"
                value={priceSheet || "default"}
                handleChange={(e) => handleSelect(e)}
                options={lists && lists.listPriceSheets}
              />
            </div>
          </div>
          <div className="one-half flex-parent">
            {/* Enable editing checkbox */}
            <div
              className={
                enableEdits
                  ? "one-third checked checkbox outline-box"
                  : "one-third checkbox outline-box"
              }
              onClick={() => handleCheck(!enableEdits)}
            >
              <Checkbox
                type="checkbox"
                name="enableEdits"
                labelText="Enable Edits"
                checked={enableEdits || false}
                handleChange={() => {}}
              />
            </div>
            {/* Show previous value checkbox */}
            <div
              className={
                showPrevious
                  ? "one-third checked checkbox outline-box"
                  : "one-third checkbox outline-box"
              }
              onClick={() => setShowPrevious(!showPrevious)}
            >
              <Checkbox
                type="checkbox"
                name="showPrevious"
                labelText="Show Old Price"
                checked={showPrevious || false}
                handleChange={() => {}}
              />
            </div>
            {/* Save edits button */}
            <button
              name={"saveEdits"}
              className={"btn one-third"}
              type="button"
              onClick={handleTableSave}
              disabled={isLoading || !enableEdits}
            >
              {isLoading ? "please wait..." : "Save Edits"}
            </button>
          </div>
          {/* --- The actual price tables --- */}
          {menu === "Price Tables" ? (
            <div className="price-sheets whole flex-parent">
              {/* Base Price Tables */}
              <SkylightPrices
                title="Residential Skylight Prices"
                priceTable={"skylightPrices"}
                pricePackage={pricePackage}
              />
              <SkylightPrices
                title="Roofer Skylight Prices"
                priceTable={"rooferSkylightPrices"}
                pricePackage={pricePackage}
              />
              {/* Sun Tunnel Price Tables */}
              <div className="one-third">
                <SunTunnelPrices
                  type="Residential"
                  priceTable={"sunTunnelPrices"}
                  pricePackage={pricePackage}
                />
                <SunTunnelPrices
                  type="Roofer"
                  priceTable={"rooferSunTunnelPrices"}
                  pricePackage={pricePackage}
                />
              </div>
              {/* Line Items Price Table */}
              <div className="one-third">
                <LineItems pricePackage={pricePackage} />
              </div>
              {/* Labor Price Table */}
              <div className="one-third">
                <Labor pricePackage={pricePackage} />                
                <Commissions pricePackage={pricePackage} />
              </div>
            </div>
          ) : (
            <div className="price-sheets whole flex-parent">
              {/* Residential/Roofer/Sun Tunnels/Extras toggle */}
              <div className="whole flex-parent">
                {["Residential", "Roofers", "Miscellaneous"].map((title, index) => {
                  return (
                    <div className="" key={index}>
                      <button
                        name={title}
                        className={category === title ? "selected btn btn-block" : "btn btn-block"}
                        type="button"
                        onClick={() => setCategory(title)}
                        disabled={isLoading}
                      >
                        {isLoading ? "please wait..." : title}
                      </button>
                    </div>
                  );
                })}
              </div>
              {/* Detailed Cost Tables */}
              {category === "Residential" && SkylightCostBlock("skylightPrices", pricePackage)}
              {category === "Roofers" && SkylightCostBlock("rooferSkylightPrices", pricePackage)}
              {category === "Miscellaneous" && //
                MiscPriceBlock(pricePackage)}
            </div>
          )}
        </div>
      </form>
    </div>
  );
};
export default AdminPriceTables;
